import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
// import Loader from "../../Components/Loader";
import masterServices from "../../Services/masterService";

export const EditPackageMaster = () => {
  const history = useHistory();
  // const [loader, setLoader] = useState(false);
  const param = history.location.state;

  const initialValues = {
    freight_data: param.data.packings,
  };

  const validationSchema = Yup.object().shape({
    freight_data: Yup.array().of(
      Yup.object().shape({
        packing_type: Yup.string().required("Required"),
        rate_per_cmb: Yup.string().required("Required"),
        minimum: Yup.string().required("Required"),
        // percentage_fright_mu: Yup.string().required("Required"),
      })
    ),
  });

  const addNewField = (errors, values, setValues) => {
    let arry = [...values.freight_data];
    if (errors && errors.freight_data !== undefined) {
      toast.error("fill initial freight data");
    } else {
      arry.push({
        packing_type: "",
        rate_per_cmb: "",
        minimum: "",
        // percentage_fright_mu: "",
      });
      setValues({ ...values, freight_data: arry });
    }
  };

  const onClickRemove = (index, values, setValues) => {
    let arry = [...values.freight_data];

    if (index === 0 && values.freight_data.length === index + 1) {
      toast.warning("The initial package is required");
    } else {
      arry.splice(index, 1);
      setValues({ ...values, freight_data: arry });
    }
  };
  const onSubmit = (fields) => {
    // setLoader(true);
    let postData = {
      packings: fields.freight_data,
    };
    masterServices.add_package(postData).then((res) => {
      if (res.status) {
        history.push("/package-master");
      } else {
        toast.error(res.message);
      }
    });
  };

  const showLabel = (item) => {
    if (item.packing_type === "carton packing") {
      return "cbm";
    } else {
        return "sq mt";

    }
  };
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <Formik
              initialValues={initialValues && initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ errors, values, touched, setValues }) => (
                <Form className="control-form">
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-3">
                          <label>Packing Type</label>
                        </div>
                        <div className="col-3">
                          <label>Rate Per</label>
                        </div>
                        <div className="col-3">
                          {/* <label>Label</label> */}
                        </div>
                        <div className="col-3">
                          <label>Minimum</label>
                        </div>
                        {/* <div className="col">
                          <label>% Freight MU</label>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <FieldArray name="freight_data">
                    {() =>
                      values.freight_data.map((ticket, i) => {
                        const ticketErrors =
                          (errors.freight_data?.length &&
                            errors.freight_data[i]) ||
                          {};
                        const ticketTouched =
                          (touched.freight_data?.length &&
                            touched.freight_data[i]) ||
                          {};
                        return (
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row align-items-center">
                                <div className="col-3">
                                  <Field
                                    name={`freight_data.${i}.packing_type`}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (ticketErrors.packing_type &&
                                      ticketTouched.packing_type
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name={`freight_data.${i}.packing_type`}
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="col-3">
                                  <Field
                                    name={`freight_data.${i}.rate_per_cmb`}
                                    type="number"
                                    className={
                                      "form-control" +
                                      (ticketErrors.rate_per_cmb &&
                                      ticketTouched.rate_per_cmb
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name={`freight_data.${i}.rate_per_cmb`}
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="col-3">
                                  <label>
                                  {showLabel(ticket)}
                                  </label>
                                 
                                </div>
                                
                                <div className="col-3">
                                  <Field
                                    name={`freight_data.${i}.minimum`}
                                    type="number"
                                    className={
                                      "form-control" +
                                      (ticketErrors.minimum &&
                                      ticketTouched.minimum
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name={`freight_data.${i}.minimum`}
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                                {/* <div className="col">
                                  <Field
                                    name={`freight_data.${i}.percentage_fright_mu`}
                                    type="number"
                                    className={
                                      "form-control" +
                                      (ticketErrors.percentage_fright_mu &&
                                      ticketTouched.percentage_fright_mu
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name={`freight_data.${i}.percentage_fright_mu`}
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div> */}
                              </div>
                            </div>
                            <div className="col-2">
                              <button
                                className="btn btn-danger w-100"
                                type="button"
                                onClick={() =>
                                  onClickRemove(i, values, setValues)
                                }
                              >
                                Remove
                              </button>
                            </div>
                            <div className="col-12">
                              <hr className="my-3" />
                            </div>
                          </div>
                        );
                      })
                    }
                  </FieldArray>

                  <p
                    className="text-primary pointer"
                    onClick={() => addNewField(errors, values, setValues)}
                  >
                    + Add New Package
                  </p>
                  <div className="mt-3 d-flex justify-content-between">
                    <button
                      className="btn btn-danger w-sm waves-effect waves-light"
                      type="button"
                      onClick={() => history.goBack()}
                    >
                      Back
                    </button>
                    <button
                      className="btn btn-primary w-sm waves-effect waves-light"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};
